export const routes = {
  home: "/",
  category: "/category",
  sources: "/sources",
  destinations: "/destinations",
  privacy: "/privacy",
  account: "/account",
  workspaces: "/workspaces",
  notifications: "/app/notifications",
  domains: "/domains",
  guides: "/guides",
  editSources: "/sources/edit",
  editDestinations: "/destinations/edit",
  trackers: "/trackers",
  wizard: "/wizard",
  leadsWizard: "/leads-wizard",
  tracker_events: "/tracker-events",
  tracker_events_create: "/tracker-events/create",
  tracker_events_edit: "/tracker-events/edit",
  landing_pages: "/landing-pages",
  landing_page_reports: "/landing-page-reports",
  create_landing_page: "/create-landing-page",
  tracker_setting: "/tracker-setting",
  connection: "/lead-connections",
  leadSources: "/lead-sources",
  leadDestinations: "/lead-destinations",
  service: "/lead-services",
  notification_view: "/notification-view",
  activity_log: "/activity-log",
  leadConnectionReports: '/lead-connection-reports',
  leadDebug: '/lead-debug',
  leadGeneralReports: '/lead-general-reports',
};

export const leadConnectionHistoryPath = (id) =>
  `${routes.leadConnectionReports}/${id}/history`;
